import React from "react";

/**
 * NestedItemFormSection - A reusable component for form sections in nested items
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Form content to display
 * @param {string} props.title - Section title
 * @param {Function} props.onClose - Function to call when close button is clicked
 * @param {string} props.className - Additional CSS classes
 */
const NestedItemFormSection = ({
  children,
  title,
  onClose,
  className = "",
}) => {
  return (
    <div className={`mt-3 p-4 card-inset ${className}`}>
      <div className="flex justify-between items-center mb-4">
        <h5 className="heading-display text-lg">{title}</h5>
        {onClose && (
          <button
            onClick={onClose}
            className="text-brand-muted hover:text-brand-charcoal"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
      </div>
      {children}
    </div>
  );
};

export default NestedItemFormSection;
